import * as React from 'react';
import { clsx as cn } from 'clsx';
import * as styles from '../../styles.css';

import { ConditionalWrapper } from '@cian/conditional-component';
import { UIHeading4, ArticleParagraph1, UIText2, ArticleParagraph2 } from '@cian/ui-kit';

import { IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';

interface IServicesProps {
  title: string;
  description?: string;
  img?: string;
  icon?: React.ReactNode;
  iconLink?: string | null;
  onClick(): void;
  isDesktop: boolean;
  isSmallDescription?: boolean;
  filled?: boolean;
}

export const OtherServices: React.FC<IServicesProps> = ({
  title,
  description,
  img,
  icon,
  iconLink,
  onClick,
  isDesktop,
  isSmallDescription,
  filled,
}) => {
  return (
    <div
      className={cn(styles['service'], {
        [styles['service-large']]: isDesktop,
        [styles['service-small']]: !isDesktop,
        [styles['service-fill']]: filled,
      })}
      onClick={onClick}
    >
      <div className={styles['content']}>
        {img && <div className={cn(styles['img'], styles[img])} />}
        {icon && <div className={styles['icon']}>{icon}</div>}
        {iconLink && <img className={styles['img']} src={iconLink} />}
        <div>
          <div className={styles['content-title']}>
            <ConditionalWrapper if={isDesktop} ThenComponent={UIHeading4} ElseComponent={UIText2}>
              {title}
            </ConditionalWrapper>
          </div>

          {isSmallDescription && description && (
            <ArticleParagraph2 color="text-secondary-default">{description}</ArticleParagraph2>
          )}
          {!isSmallDescription && description && (
            <ArticleParagraph1 color="text-secondary-default">{description}</ArticleParagraph1>
          )}
        </div>
      </div>
      {isDesktop && <IconActionChevronRight16 />}
    </div>
  );
};

OtherServices.displayName = 'OtherServices';
